// removed by extract-text-webpack-plugin
module.exports = {"inline-donate":"inline-donate___3w72D","inline-donate__icon":"inline-donate__icon___2HuDi","inline-donate__headline":"inline-donate__headline___WZrJi h2___hzLuT","inline-donate__copy":"inline-donate__copy___3FIWP h3___5u0xZ","inline-donate__link":"inline-donate__link___3DVTg"};


//////////////////
// WEBPACK FOOTER
// ./src/core/InlineDonate/InlineDonate.css
// module id = 925
// module chunks = 0